import { render, staticRenderFns } from "./HMSwitch.vue?vue&type=template&id=2a496442&scoped=true&"
import script from "./HMSwitch.vue?vue&type=script&lang=js&"
export * from "./HMSwitch.vue?vue&type=script&lang=js&"
import style0 from "./HMSwitch.vue?vue&type=style&index=0&id=2a496442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a496442",
  null
  
)

export default component.exports